import type { Meilisearch_Auteur } from '@/lib/api/meilisearch-types';

export const computeAuteurPhoto = (auteur: Meilisearch_Auteur) => {
  if (auteur?.photo) return auteur.photo;

  const defaultPics = {
    F: {
      base: '14467784-0a80-4cc4-bbca-3d39f5186e70',
      xx: '5061fb26-a097-418a-a9e9-f2504c16544a',
      xix: 'c342c96d-caf2-41da-8d55-d87d889bc10a',
    },
    M: {
      base: 'baf5aeca-b453-46ab-b66e-1af612a8951b',
      xx: 'd87ec715-44d3-4dee-baba-ae1dc0a34734',
      xix: 'bca9f36b-1ad6-4628-aa5b-d2a2d399e81b',
    },
  };

  const { genre = 'M', siecle_principal: mainCentury } = auteur || {};
  if (defaultPics[genre]) {
    if (mainCentury === '20' || mainCentury === '21') {
      return defaultPics[genre].xx;
    }

    if (mainCentury === '19') {
      return defaultPics[genre].xix;
    }

    return defaultPics[genre].base;
  }
  return defaultPics.M.base;
};
